/**
 * Get duration in milliseconds from a start and end dates as 8601 timestamps
 * @param {*} startTime
 * @param {*} endTime
 * @returns
 */
export const getDuration = (startTime, endTime) => {
  return new Date(endTime).getTime() - new Date(startTime).getTime()
}
